
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{
        CheckBox
    }
})
export default class AffChecklist extends Vue {

    @Prop({required: true})
    applicationId!: string;

    dataReady = false;
    error = '';
    efspFiled = false;
    affSigned = false;

    mounted(){
        this.dataReady = false;
        this.getApplicationInfo(this.applicationId);        
    }

    public getApplicationInfo(applicationId) { 


        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {

            const applicationData = response.data;
            console.log(applicationData)  
        
            const stepGETSTART = this.getStepResultByName(applicationData, 'GETSTART');
            const apps = stepGETSTART.submittedPdfList

            if (apps.includes('AFF') && apps.includes('EFSP')){
                this.affSigned = true;
                if (apps.includes('EFSP')){
                    this.efspFiled = true;
                }
            }                             
            
            Vue.nextTick(()=> this.dataReady = true);

        }, err => {
            this.error = err;        
        });
    }

    public getStepResultByName(applicationData, stepName){
        if(applicationData?.steps){
            const steps = applicationData.steps.filter(step => step.name == stepName);
            if(steps.length == 1) return steps[0].result
        }
        return {}
    }

}
